import html2canvas from 'html2canvas'



 // printAnyMaps ::
 export function printAnyMaps() {
  const $body = document.getElementsByTagName('body');
  const $mapContainer = document.querySelector('#urbit-map');
  const $mapContainerParent = $mapContainer.parentElement;
  const $printContainer =  document.createElement('div');
  $printContainer.style.position = "relative"
  

  $printContainer.style.height = $mapContainer['style'].height
  $printContainer.append($mapContainer)
   $body[0].append($printContainer) 
    // .prependTo($body);

  // const $content = $body[0]
  //   .not($printContainer)
  //   .not('script')
  //   .detach();

  /**
   * Needed for those who use Bootstrap 3.x, because some of
   * its `@media print` styles ain't play nicely when printing.
   */
  // const $patchedStyle = $('<style media="print">')
  //   .text(`
  //     img { max-width: none !important; }
  //     a[href]:after { content: ""; }
  //   `)
  //   .appendTo('head');

  // window.print();

  // $body.prepend($content);
  $mapContainerParent.prepend($mapContainer);

  $printContainer.remove();
  // $patchedStyle.remove();
}

export const exportAsImage = async (el, imageFileName) => {
  // console.log(el)
  
  // // if (window.chrome) { // Fix for Chrome
  // var transform = document.querySelector('.gm-style>div:nth-child(2)>div')['style'].transform ///$(".gm-style>div:first>div").css("transform");
  // var comp = transform.split(',') //split up the transform matrix
  // var mapleft = parseFloat(comp[4]) //get left value
  // var maptop = parseFloat(comp[5]) //get top value
  // // $(".gm-style>div:first>div").css({ //get the map container. not sure if stable
  // //   "transform": "none",
  // //   "left": mapleft,
  // //   "top": maptop,
  // // });
  // // }
  // document.querySelectorAll('.gm-style>div:nth-child(2)').forEach(function (el) {
  //   console.log(el)
  //   // el['style'].transform
  //   // $(this).css({"transform":"translate("+(-mapleft)+"px,"+ (-maptop
  // })

  // // html2canvas(document.querySelector("#map"), {useCORS: true}).then(canvas => {
  // //   // $('#screenshot').empty().html(canvas);
  // //   // if (window.chrome) { // Fix for Chrome
  // //   document.querySelectorAll('.gm-style>div:first>div').forEach(function(el){
  // //     console.log(el)
  // //     // el['style'].transform
  // //     // $(this).css({"transform":"translate("+(-mapleft)+"px,"+ (-maptop
  // //   })
  // //     // $(".gm-style>div:first>div").css({
  // //     //   left: 0,
  // //     //   top: 0,
  // //     //   "transform": transform
  // //     // });
  // //   // }
  // // });

  // const canvas = await html2canvas(el, {logging: true, useCORS: true})
  // const image = canvas.toDataURL('image/png', 1.0)
  // console.log(image)
  // //   downloadImage(image, imageFileName)
  // return image
}

const downloadImage  = async (blob, fileName) => {
  const fakeLink = window.document.createElement('a')
  // fakeLink.style = "display:none;";
  fakeLink.download = fileName

  fakeLink.href = blob

  document.body.appendChild(fakeLink)
  fakeLink.click()
  document.body.removeChild(fakeLink)

  fakeLink.remove()
}

export const exportImage = async (elCanvas, imageFileName) => {
  // var content = window.document.getElementById("#urbit-map"); // get you map details
  //   var newWindow = window.open(); // open a new window
  //   newWindow.document.write(content.innerHTML); // write the map into the new window
  //   newWindow.print();
  // printAnyMaps()
  const isChrome = !!window['chrome'] && (!!window['chrome'].webstore || !!window['chrome'].runtime);
 
  if (isChrome) { // Fix for Chrome

    // const mapNode = document.querySelectorAll(".gm-style>div:nth-child(2) ");
    // console.log(mapNode)
    // mapNode.forEach(m => {
    //   console.log(m)
    //   const transformMatrix = getComputedStyle(m).transform.split(",");
    //   console.log(transformMatrix)
    //   // m.setAttribute("style",`left:${parseFloat(transformMatrix[4])}px; top:${parseFloat(transformMatrix[5])}px; transform:none; position:absolute; z-index:9999;`
    //   m.setAttribute("style",`left:0px; top:0px; transform:none; position:absolute; z-index:9999;`
    //   );


    // })
  }
//     var transform = elCanvas.querySelector('div:nth-child(2)>div')['style'].transform 
//     var comp = transform.split(","); //split up the transform matrix
//     var mapleft = 0 //parseFloat(comp[4]); //get left value
//     var maptop = 0 //parseFloat(comp[5]); //get top value
//     console.log(transform)
    
//     // $(".gm-style>div:first>div").css({ //get the map container. not sure if stable
//     //   "transform": "none",
//     //   "left": mapleft,
//     //   "top": maptop,
//     // });
//   }

// const mapNode = document.querySelector('.gm-style>div>div>div:last-child>div');
// const transformMatrix = getComputedStyle(mapNode).transform.split(',');
// mapNode.setAttribute(
//   'style',
//   'left:' +
//     parseFloat(transformMatrix[4]) +
//     'px;top:' +
//     parseFloat(transformMatrix[5]) +
//     'px;transform: none;position: absolute;z-index: 983;'
// );
// document.getElementById('map_image').setAttribute('src','')
  html2canvas(elCanvas, {
    useCORS: true,
    allowTaint: true,
    // async:false,
    ignoreElements: (node) => {
      // console.log(node)
      return node.nodeName === 'IFRAME';
    }
  }).then(async (canvas) => {
    // console.log(canvas)
    // var tempcanvas=document.createElement('canvas');
    // // console.log(tempcanvas)
    // // tempcanvas.width=1350;
    // // tempcanvas.height=700;
    // var context=tempcanvas.getContext('2d');
    // context.drawImage(canvas,0,0,1350,700,0,0,1350,700);
 
    // console.log(image)
    // var link=document.createElement("a");
    // link.href=tempcanvas.toDataURL('image/jpg');   //function blocks CORS


   

// document.body.append()
//     // console.log(canvas)
//     // canvas.querySelectorAll('div:nth-child(2)>div').forEach(function(el){
//     //   console.log(el)
//     //   // el["style"].setProperty("transform",transform);
//     //   // el["style"].setProperty("left",'0');
//     //   // el["style"].setProperty("top",'0');
//     //   // el['style'].transform
//     //   // $(this).css({"transform":"translate("+(-mapleft)+"px,"+ (-maptop
//     // })
//     // $('#screenshot').empty().html(canvas);
//     // if (window.chrome) { // Fix for Chrome
//     //   $(".gm-style>div:first>div").css({
//     //     left: 0,
//     //     top: 0,
//     //     "transform": transform
//     //   });
//     // }
   
    const image = canvas.toDataURL('image/png', 1.0)
    // document.getElementById('map_image').setAttribute('src',image)
    await downloadImage(image, imageFileName)
  })

  // console.log(el)

  // document.querySelector('.gm-style>div:nth-child(2)>div')
  // // if (window.chrome) { // Fix for Chrome
  //   var transform = document.querySelector('.gm-style>div:nth-child(2)>div')['style'].transform ///$(".gm-style>div:first>div").css("transform");
  //   var comp = transform.split(","); //split up the transform matrix
  //   var mapleft = parseFloat(comp[4]); //get left value
  //   var maptop = parseFloat(comp[5]); //get top value
  //   document.querySelectorAll('.gm-style>div:nth-child(2)>div').forEach((el)=>{
  //     el["style"].setProperty("transform","none");
  //     el["style"].setProperty("left",mapleft);
  //     el["style"].setProperty("transform",maptop);
  //   })
  //   // $(".gm-style>div:first>div").css({ //get the map container. not sure if stable
  //   //   "transform": "none",
  //   //   "left": mapleft,
  //   //   "top": maptop,
  //   // });
  // // }
  // document.querySelectorAll('.gm-style>div:nth-child(2)').forEach(function(el){
  //   console.log(el)
  //   // el['style'].transform
  //   // $(this).css({"transform":"translate("+(-mapleft)+"px,"+ (-maptop
  // })

  // // html2canvas(document.querySelector("#map"), {useCORS: true}).then(canvas => {
  // //   // $('#screenshot').empty().html(canvas);
  // //   // if (window.chrome) { // Fix for Chrome
  // //   document.querySelectorAll('.gm-style>div:first>div').forEach(function(el){
  // //     console.log(el)
  // //     // el['style'].transform
  // //     // $(this).css({"transform":"translate("+(-mapleft)+"px,"+ (-maptop
  // //   })
  // //     // $(".gm-style>div:first>div").css({
  // //     //   left: 0,
  // //     //   top: 0,
  // //     //   "transform": transform
  // //     // });
  // //   // }
  // // });

  // const canvas = await html2canvas(el,{logging: true,
  //   useCORS: true,

  // })

  // return image
}


